import DevelopmentUnitParkingViewModel from './DevelopmentUnitParkingViewModel';
import EmployeesViewModel from './EmployeesViewModel';
import FacilitiesViewModel from './FacilitiesViewModel';
import OpeningTimesViewModel from './OpeningTimesViewModel';
import ResidentialUnitsViewModel from './ResidentialUnitsViewModel';
import RetailDetailsViewModel from './RetailDetailsViewModel';


export default class DevelopmentDetailsViewModel {

    devNo: string | null = null;
    nonFoodRFA: number | null = null;
    numberOfUnits: number | null = null;
    gfa: number | null = null;
    gfaNotInUse: number | null = null;
    rfa: number | null = null;
    mezzanineGFA: number | null = null;
    mezzanineRFA: number | null = null;
    externalGFA: number | null = null;
    internalGFA: number | null = null;
    numberOfStalls: number | null = null;
    carHire: number | null = null;
    
    occupiedDwelling: number | null = null;
    unoccupiedDwelling: number | null = null;
    totalDwellings: number | null = null;
    privatelyOwnedUnits: number | null = null;
    nonPrivatelyOwnedUnits: number | null = null;
    siteAreaExcludingPublicFeatures: number | null = null;

    externalStorage: number | null = null;
    unitDensity: number | null = null;
    numberOfBedsCare: number | null = null;
    residentsCare: number | null = null;
    residentsTotal: number | null = null;
    totalNumberOfPupils: number | null = null;
    totalNumberOfStudents: number | null = null;
    totalNumberOfBeds: number | null = null;
    totalNumberOfDoctors: number | null = null;
    totalNumberOfPatients: number | null = null;
    totalNumberOfSurgeons: number | null = null;
    totalNumberOfBedrooms: number | null = null;
    totalNumberOfIndoorSeats: number | null = null;
    totalNumberOfOutdoorSeats: number | null = null;
    totalNumberOfSeatsAtSite: number | null = null;
    totalNumberOfSeatsAtSiteRfa: number | null = null;
    totalCourts: number | null = null;
    totalPitches: number | null = null;
    totalBerths: number | null = null;
    totalGolfHoles: number | null = null;
    totalRanges: number | null = null;
    areaOfIceRink: number | null = null;
    driveThroughLaneCap: number | null = null;
    driveThroughOrderingPoints: number | null = null;
    homeDeliveryServiceAvailableSite: string | null = null;
    preOrderPickUpBays: number | null = null;
    driveThroughLaneCapExceeded: string | null = null;
    totalSeats: number | null = null;
    totalScreens: number | null = null;
    totalLanes: number | null = null;
    totalWasteDisposalUnits: number | null = null;
    totalRecyclingUnits: number | null = null;
    totalBaysDisposalAndRecycling: number | null = null;
    totalChargingBays: number | null = null;
    totalFillingBays: number | null = null;
    totalParkingExcludingFillingBays: number | null = null;
    totalChargingBaysUsingUnits: number | null = null;
    totalParkingExcludingChargingBays: number | null = null;
    totalBays: number | null = null;
    bayNumber: number | null = null;
    detailsOfNonResidentialLandUses: string | null = null;
    gfaNonResidentialBuildings: number | null = null;
    distanceToNearestSimilarSite: number | null = null;
    nameOfNearestSimilarSite: string | null = null;
    siteArea: number | null = null;
    siteAreaExcluding: number | null = null;
    tradeName: string | null = null;
    yearOfSiteOpening: number | null = null;
    openingTimes: OpeningTimesViewModel | null = null;
    employees: EmployeesViewModel | null = null;
    facilities: FacilitiesViewModel | null = null;
    residentialUnits: ResidentialUnitsViewModel | null = null;
    retailDetails: RetailDetailsViewModel | null = null;
    parkingDetails: DevelopmentUnitParkingViewModel | null = null;
    comments: string | null = null;
}